// extracted by mini-css-extract-plugin
module.exports = {"showMoreButton":"styles-module--showMoreButton--3JkVr","wrapper":"styles-module--wrapper--P77XS","inner":"styles-module--inner--3mgqv","icon":"styles-module--icon--1-sJb"};